export const ACTION_PRODUCT_SWITCH_COMPOSITION =
  'ACTION_PRODUCTSWITCH_COMPOSITION';
export const ACTION_UPDATE_SIDE_PRINTSTYLE = 'ACTION_UPDATE_SIDE_PRINTSTYLE';

import { NAMESPACE } from './namespace';
export const ACTION_COMPOSITION_PRODUCT_SWITCH_COMPOSITION = `${NAMESPACE}${ACTION_PRODUCT_SWITCH_COMPOSITION}`;
export const ACTION_COMPOSITION_UPDATE_SIDE_PRINTSTYLE = `${NAMESPACE}${ACTION_UPDATE_SIDE_PRINTSTYLE}`;
